import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h2", { class: "text-xl font-bold text-textPrimary text-left" }, "Reprovar registro", -1)
const _hoisted_2 = { class: "flex flex-col gap-4" }
const _hoisted_3 = { class: "flex flex-col sm:flex-row sm:justify-end gap-3" }

import { ref, watch } from 'vue'
import Modal from '@/components/designSystem/modals/Modal.vue'
import OutlineButton from '@/components/designSystem/Buttons/OutlineButton/index.vue'
import FilledButton from '@/components/designSystem/Buttons/FilledButton/index.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DsAttendanceRejectModal',
  props: {
    modelValue: { type: Boolean },
    saving: { type: Boolean },
    rejectionReasonOptions: {},
    initialReason: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit }) {

const props = __props;





const selectedReason = ref<string | null>(null)
const observation = ref('')
const requestNewSheet = ref(false)

watch(
  () => props.modelValue,
  (open) => {
    if (open) {
      selectedReason.value = props.initialReason ?? null
      observation.value = ''
      requestNewSheet.value = false
    }
  }
)

function handleClose() {
  emit('update:modelValue', false)
}

function handleConfirm() {
  if (!selectedReason.value) return
  emit('confirm', {
    reason: selectedReason.value,
    justification: observation.value || undefined,
    requestNewSheet: requestNewSheet.value === true
  })
}

return (_ctx: any,_cache: any) => {
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createBlock(Modal, {
    "modal-active": _ctx.modelValue,
    "has-header-border": "",
    "has-footer-border": "",
    "max-width": "max-w-[520px]",
    onClose: handleClose
  }, {
    header: _withCtx(() => [
      _hoisted_1
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(OutlineButton, {
          text: "Cancelar",
          width: "96px",
          height: "40px",
          "data-testid": "reject-cancel-button",
          onClick: handleClose
        }),
        _createVNode(FilledButton, {
          text: "Confirmar reprovação",
          class: "bg-negative",
          width: "200px",
          height: "40px",
          disabled: !selectedReason.value || _ctx.saving,
          "data-testid": "reject-confirm-button",
          onClick: handleConfirm
        }, null, 8, ["disabled"])
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_v_autocomplete, {
          modelValue: selectedReason.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedReason).value = $event)),
          items: _ctx.rejectionReasonOptions,
          "item-title": "title",
          "item-value": "value",
          label: "Justificativa de reprovação",
          variant: "outlined",
          density: "compact",
          "hide-details": "",
          "data-testid": "reject-reason-select"
        }, null, 8, ["modelValue", "items"]),
        _createVNode(_component_v_textarea, {
          modelValue: observation.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((observation).value = $event)),
          label: "Observação (opcional)",
          variant: "outlined",
          density: "compact",
          rows: "3",
          "hide-details": "",
          "data-testid": "reject-observation-input"
        }, null, 8, ["modelValue"]),
        _createVNode(_component_v_checkbox, {
          "model-value": requestNewSheet.value,
          "true-value": true,
          "false-value": false,
          label: "Solicitar envio de nova folha",
          density: "compact",
          "hide-details": "",
          "data-testid": "reject-request-new-sheet-checkbox",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (requestNewSheet.value = $event === true))
        }, null, 8, ["model-value"])
      ])
    ]),
    _: 1
  }, 8, ["modal-active"]))
}
}

})